import React from 'react';
import { Link } from 'react-router-dom';
import './Projects.scss';

import project1 from '../../assets/images/project1.jpg';
import project2 from '../../assets/images/project2.jpg';
import project3 from '../../assets/images/project3.jpg';
import project4 from '../../assets/images/project4.jpg';

const Projects = () => {
  const projects = [
    {
      id: 1,
      title: "2D to 3D Building Asset Mapping",
      description: "Advanced conversion of 2D structures to 3D models for enhanced visualization and analysis",
      image: project1,
      highlights: [
        "Transformed basic shapes into realistic 3D objects",
        "Enabled digital twins, architecture planning, and emergency management",
        "Implemented two conversion methods: Layer 3D to Feature Class and Copy-Paste Special",
        "Applied to university campus mapping with precise 3D representations"
      ],
      year: "2024"
    },
    {
      id: 2,
      title: "GIS BaseMap Creation",
      description: "Custom basemap development for specialized applications and operational layers",
      image: project2,
      highlights: [
        "Designed for targeted web/mobile GIS applications",
        "Created framework for parcels, utilities, hydrology and planning data",
        "Implemented multi-resolution display capabilities",
        "Optimized for operational layer visualization"
      ],
      year: "2023"
    },
    {
      id: 3,
      title: "Telecom Tower Asset Mapping",
      description: "Comprehensive 2D mapping of telecom infrastructure components",
      image: project3,
      highlights: [
        "Mapped cell towers, fiber routes, and network nodes",
        "Enabled optimal coverage and signal strength analysis",
        "Integrated transmission equipment and infrastructure components",
        "Supported network planning and maintenance operations"
      ],
      year: "2023"
    },
    {
      id: 4,
      title: "Cadastral Map Digitization",
      description: "Scanning and conversion of land records for modern management systems",
      image: project4,
      highlights: [
        "Preserved historical land records through high-resolution scanning",
        "Implemented georeferencing for accurate coordinate alignment",
        "Integrated with GIS platforms for efficient land administration",
        "Enhanced transparency in property ownership and disputes"
      ],
      year: "2022"
    }
  ];

  return (
    <div className="projects-page">
      <div className="container">
        <Link to="/services" className="back-button">
          &larr; Back to Services
        </Link>
        
        <h1>Our Projects</h1>
        <p className="subtitle">Explore our recent work and success stories</p>
        
        <div className="projects-grid">
          {projects.map(project => (
            <div key={project.id} className="project-card">
              <div className="project-image">
                <img src={project.image} alt={project.title} />
              </div>
              <div className="project-content">
                <h2>{project.title}</h2>
                {/* <span className="year">{project.year}</span> */}
                <p>{project.description}</p>
                <ul className="highlights">
                  {project.highlights.map((highlight, index) => (
                    <li key={index}>{highlight}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Projects;